export default __webpack_public_path__ + "static/media/logo.1411451c.png";